module.exports = __webpack_public_path__ + "static/media/large-field.8760153c.PNG";